'use client';
import React from 'react';

const ProductGridSkeleton = () => {
  return (
    <div className="product-preloader">
      {/* Header skeleton */}

      {/* Product grid skeleton */}
      <div className="product-preloader__grid">
        {[...Array(16)].map((_, index) => (
          <div key={index} className="product-preloader__card p-0">
            {/* Image placeholder */}
            <div className="product-preloader__card-image"></div>

            {/* Product info */}
            <div className="product-preloader__card-title"></div>
            <div className="product-preloader__card-price"></div>

            {/* Rating */}
            <div className="product-preloader__card-rating"></div>

            {/* Button */}
            <div className="product-preloader__card-button"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductGridSkeleton;
